import truncate from 'lodash/truncate'

export type SourceType = 'ehq'
export type OwnerType = 'Survey'
export type FilterType = 'question' | string

export interface FilterAttributes {
  visible: boolean
  icon: string
  options: null | []
  selectType: 'single' | 'multiple'
  label: string
  attribute: string
  apiSource: string
}

export type Filters = {
  [key in FilterType]: FilterAttributes
}

export interface Template {
  filters: Filters
}

export type MultiSelectValue = {
  label: string
  id: string
}

export const MAX_CHARACTER_ALLOWED_INSIDE_DROPDOWN = 29

export const generateAPIPath = (
  apiSource: string,
  project_id: string,
  owner_id: string,
) =>
  apiSource
    .replace(/{project_id}/g, project_id)
    .replace(/{owner_id}/g, owner_id)

export const shouldShowTooltip = (str: string) =>
  str.length > MAX_CHARACTER_ALLOWED_INSIDE_DROPDOWN

export const truncatedLabel = (str: string) =>
  truncate(str, {
    length: MAX_CHARACTER_ALLOWED_INSIDE_DROPDOWN,
  })
